import * as Yup from "yup";

export const userSchema = Yup.object({
  firstName: Yup.string().required("Firstname is required"),
  lastName: Yup.string().required("Lastname is required"),
  phoneNumber: Yup.string(),
  roleName: Yup.string().required("Role is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("User Email Address is required"),
  countryId: Yup.string(),
});

export const roleSchema = Yup.object({
  roleName: Yup.string().required("Role name is required"),
  permissionIds: Yup.array()
    .of(Yup.string())
    .min(1, "At least one permission is required")
    .required("At least one permission is required"),
});

export const editRoleSchema = Yup.object({
  roleId: Yup.string().required("Role name is required"),
  permissionIds: Yup.array()
    .of(Yup.string())
    .min(1, "At least one permission is required")
    .required("At least one permission is required"),
});


